export default __webpack_public_path__ + "static/media/rmuti.3713ce7e.png";